var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8406 4.79922C15.8406 4.79922 15.6844 3.69609 15.2031 3.21172C14.5938 2.57422 13.9125 2.57109 13.6 2.53359C11.3625 2.37109 8.00313 2.37109 8.00313 2.37109H7.99687C7.99687 2.37109 4.6375 2.37109 2.4 2.53359C2.0875 2.57109 1.40625 2.57422 0.796875 3.21172C0.315625 3.69609 0.1625 4.79922 0.1625 4.79922C0.1625 4.79922 0 6.09609 0 7.38984V8.60234C0 9.89609 0.159375 11.193 0.159375 11.193C0.159375 11.193 0.315625 12.2961 0.79375 12.7805C1.40313 13.418 2.20313 13.3961 2.55938 13.4648C3.84063 13.5867 8 13.6242 8 13.6242C8 13.6242 11.3625 13.618 13.6 13.4586C13.9125 13.4211 14.5938 13.418 15.2031 12.7805C15.6844 12.2961 15.8406 11.193 15.8406 11.193C15.8406 11.193 16 9.89922 16 8.60234V7.38984C16 6.09609 15.8406 4.79922 15.8406 4.79922ZM6.34688 10.0742V5.57734L10.6687 7.83359L6.34688 10.0742Z",
    fill: "#EF3E37"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.a48086131495bd9afa6a4323f057f255.svg";
export { ForwardRef as ReactComponent };